import React from "react";
import TotalRecentHx from "./../TotalRecentHx";
import DashboardCalendar from "./../DashboardCalendar";

export default function HmLayout2({ className }) {
  return (
    <div>
        <DashboardCalendar className="mb-10"/>
        <TotalRecentHx className="mb-10"/>
    </div>
  );
}
